export default function() {
  return {
	type: 'blog',
    info: [
      {
        tit: '求职意向',
        content: [
          [{
            tip: '期望职位',
            detail: '前端开发'
          }, {
            tip: '期望行业',
            detail: '计算机软件'
          }, {
            tip: '期望地区',
            detail: '吉林市'
          }, {
            tip: '求职类型',
            detail: '全职'
          }, {
            tip: '开始工作',
            detail: '2015.07'
          }, {
            tip: '工作时间',
            detail: '10年'
          }, {
            tip: '到岗条件',
            detail: '离职 | 7天'
          }]
        ]
      },
      {
          tit: '个人爱好',
          content: [
              [{
                  tip: '工作爱好',
                  detail: 'UI设计'
              },
      		{
                  tip: '生活爱好',
                  detail: '小说'
              },
      		{
                  tip: '运动爱好',
                  detail: '游泳'
              },
      		{
                  tip: '其他爱好',
                  detail: '指绘插画、画娃妆、设计娃衣、软装设计'
              }]
          ]
      },
      {
        tit: '教育背景',
        content: [
          [{
              tip: '毕业院校',
              detail: '北华大学'
            }, {
              tip: '专业名称',
              detail: '网络工程'
            },
            {
              tip: '学历',
              detail: '本科'
            },
            {
              tip: '学位',
              detail: '学士'
            }, {
              tip: '入学时间',
              detail: '2011.09'
            }, {
              tip: '毕业时间',
              detail: '2015.07'
            }
          ]
        ]
      },
      {
        tit: 'Logo拆解',
        content: [
          [{
              tip: 'F',
              detail: 'FE前端'
            }, {
              tip: 'U',
              detail: 'UI设计'
            },
            {
              tip: 'N',
              detail: 'Novel小说'
            },
            {
              tip: '个性签名',
              detail: '不热爱看小说的UI设计不是好前端'
            }
          ]
        ]
      },
      {
        tit: '自我评价',
        content: [
          [{
            tip: '',
            contents: [
              '【设计与页面重构】 审美良好，精通ps，熟练掌握figma，善于使用团队协作平台“摹客”、“月维”给前端开发交付设计稿，确保页面能高度还原。能够不使用ui框架手写适应各种设备的响应式网页，可以独立完成UI设计工作，有10+落地项目经验。',
              '【前端与网络通信】 掌握vue全家桶、uniapp、electron桌面应用开发、Jquery、es6、前后端交互流程与前后端分离的开发模式，熟练使用es6的Promise、es7的async。掌握原生js深层原理，可快速定位js问题。熟练使用Vue - cli搭建Vue基础架构， 熟悉Vue工程化组件化开发， 可以独立完成前端工作。',
              '【自学能力】 对设计兴趣浓厚，自学能力强，兴趣便是学习的最强驱动力。'
            ],
            detail: '集UI设计、前端开发技能于一体，工作以来所有技能皆是自学所得。<br/><br/>1、【设计与页面重构】 审美良好，精通ps，熟练掌握figma，善于使用团队协作平台“摹客”、“月维”给前端开发交付设计稿，确保页面能高度还原。能够不使用ui框架手写适应各种设备的响应式网页，可以独立完成UI设计工作，有10+落地项目经验。<br/><br/>2、【前端与网络通信】 掌握vue全家桶、uniapp、electron桌面应用开发、Jquery、es6、前后端交互流程与前后端分离的开发模式，熟练使用es6的Promise、es7的async。掌握原生js深层原理，可快速定位js问题。熟练使用Vue - cli搭建Vue基础架构， 熟悉Vue工程化组件化开发， 可以独立完成前端工作。<br/><br/> 3、【自学能力】对前端兴趣浓厚，自学能力强，兴趣便是学习的最强驱动力。 '

          }]
        ]
      }, {
        tit: '职业技能',
        content: [
          [{
            tip: '技术名称',
            detail: 'Vue'
          }, {
            tip: '掌握程度',
            detail: 80
          }],
          [{
            tip: '技术名称',
            detail: 'uniapp'
          }, {
            tip: '掌握程度',
            detail: 80
          }],
          [{
            tip: '技术名称',
            detail: '桌面应用开发electron'
          }, {
            tip: '掌握程度',
            detail: 80
          }],
          [{
            tip: '技术名称',
            detail: '原生JavaScript'
          }, {
            tip: '掌握程度',
            detail: 80
          }],
          [{
            tip: '技术名称',
            detail: 'Jquery'
          }, {
            tip: '掌握程度',
            detail: 80
          }],
		  
		    [{
		      tip: '软件名称',
		      detail: 'PS'
		    }, {
		      tip: '掌握程度',
		      detail: 95
		    }],
		    [{
		      tip: '软件名称',
		      detail: 'figma'
		    }, {
		      tip: '掌握程度',
		      detail: 70
		    }],
		    [{
		      tip: '平台名称',
		      detail: '摹客（设计交付平台）'
		    }, {
		      tip: '掌握程度',
		      detail: 95
		    }],
		    [{
		      tip: '平台名称',
		      detail: '月维（设计交付平台）'
		    }, {
		      tip: '掌握程度',
		      detail: 70
		    }],
        ]
      }, {
        tit: '工作经历',
        content: [
		  // 奥丁创新科技
          [{
            tip: '公司名称',
            detail: '奥丁创新科技(吉林)有限公司',
            tip2: '公司类型',
            detail2: '软件开发',
            bold: true
          }, {
            tip: '工作时间',
            detail: '2020.10 - 2025.07（5年）'
          }, {
            tip: '职位名称',
            detail: '前端开发工程师 + UI设计师'
          }, {
            tip: '工作描述',
            detail: '<br/>1、负责产品功能前端实现、保证业务操作流畅、高度还原设计稿样式、前后端数据交互等。<br/>2、负责设计UI界面，把握整体风格与规范。<br/>3、负责产品版本迭代，提高用户体验。<br/>4、涉及类型：微信小程序、支付宝小程序、微信公众号、安卓应用（webAPP）、自助机桌面应用、B端管理系统……'
          }],
		  // 城市信息
          [{
            tip: '公司名称',
            detail: '吉林市城市信息技术有限公司',
            tip2: '公司类型',
            detail2: '网站开发',
            bold: true
          }, {
            tip: '工作时间',
            detail: '2017.03 - 2020.09（3.5年）'
          }, {
            tip: '职位名称',
            detail: 'WEB前端 + 网页设计师 + UI设计师'
          }, {
            tip: '工作描述',
            detail: '<br/>1、主要负责"吉林市人民政府"网站的开发与维护。<br/>2、负责吉林市政府下辖多个部门机构的网站前端与网页设计。<br/>3、负责公司其他项目的前端、网页设计、UI设计，及少量平面设计。'
          }],
		  // 江云
          [{
            tip: '公司名称',
            detail: '吉林市江云科技有限公司',
            tip2: '公司类型',
            detail2: '商家平台',
            bold: true
          }, {
            tip: '工作时间',
            detail: '2015.07 - 2016.07（1年）'
          }, {
            tip: '职位名称',
            detail: '网页设计师 + UI设计师'
          }, {
            tip: '工作描述',
            detail: '负责移动端网页设计与制作，根据需求设计App页面、公司官网和pc端后台管理系统部分网页，解决各种浏览器兼容性问题。'
          }]
        ]
      }, {
        tit: 'UI设计/前端主要项目',
        content: [
		  // ---------------------------------------------纯UI
		  // H5专题活动
		  [{
		    tip: '项目名称',
		    detail: '多个手机端H5专题活动',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `原创手机端H5封面/活动页（其他相关页面暂时无法获取），已下线。
			<br/>（PC端可右键-在新标签页中打开图片）`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`040奥丁投票.jpg`,
		  		`042统战H5页面1.jpg`,
		  		`042统战H5页面.jpg`,
		  	]
		  }],
		  // 眼保健平台
		  [{
		    tip: '项目名称',
		    detail: '眼保健平台（微信小程序）',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿。`
		  }, {
		    tip: '作品展示',
			detail: '',
		    img: [
				`0001眼保健.jpg`,
				`0001眼保健2.jpg`,
			]
		  }],
		  // 江城政协
		  [{
		    tip: '项目名称',
		    detail: '江城政协（webApp）',
		    bold: true
		  }, {
		    tip: '设计时间',
		    detail: '2019年'
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `专为吉林省政协委员会打造的办公服务软件，包括政协新闻、政协概况、综合办公、个人中心四大板块。在“综合办公”栏目中，设计了提案动态管理系统，简称“掌上提案”。委员进入“综合办公”板块就能进行提案交办，并且可以实时查看审核办理的情况，做到流程过程全程追溯。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`048江城政协app.png`,
		  	]
		  }],
		  // 会议打卡
		  [{
		    tip: '项目名称',
		    detail: '合规测评（微信小程序）',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0002合规测评.jpg`,
		  	]
		  }],
		  // 会议打卡
		  [{
		    tip: '项目名称',
		    detail: '会议打卡（微信小程序）',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`049会议打卡.png`,
		  	]
		  }],
		  // 吉路通
		  [{
		    tip: '项目名称',
		    detail: '吉路通（webApp）',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿，无设计稿直接边码静态页面边美化。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`050吉路通.jpg`,
		  	]
		  }],
		  // 微心愿
		  [{
		    tip: '项目名称',
		    detail: '微心愿（webApp）',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿，无设计稿直接边码静态页面边美化。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`050微心愿.jpg`,
		  	]
		  }],
		  // 金融借贷
		  [{
		    tip: '项目名称',
		    detail: '金融借贷（APP）',
		    bold: true
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`047贷款app.png`,
		  	]
		  }],
		  // 多语言
		  [{
		    tip: '项目名称',
		    detail: '吉林市人民政府多语言版本风格首页/日文版、英文版（web网页）',
		    bold: true
		  }, {
		    tip: '设计时间',
		    detail: '2020年'
		  }, {
		    tip: '负责标签',
		    detail: 'UI'
		  },{
		    tip: '项目描述',
		    detail: `项目未上线，飞机稿。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`015日文1稿.jpg`,
		  		`023多语言版本英语14.jpg`,
		  	]
		  }],
		  // ---------------------------------------------复合型
		  // 自助机
		  [{
		    tip: '项目名称',
		    detail: '吉林市人民医院自助机系统（桌面应用）',
		    bold: true
		  }, {
		    tip: '开发时间',
		    detail: '2021.04 - 2021.12'
		  }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【作品地址】吉林市人民医院二楼大屏自助机，医院内网运行，无法线上查看，右侧视频可查看基本挂号功能。
		  							<br/>2、【项目概况】对接吉林市人民医院HIS系统、吉林市医保接口，实现患者在院内自助挂号缴费等需求。
		  							<br/>3、【主要功能】医保患者通过电子医保卡、自费患者通过电子健康卡进行挂号、缴费、报告查询、住院信息查询、打印各种小票等功能。
		  							<br/>4、【技术栈】electron桌面应用框架、Vue全家桶、element-ui等
		  							<br/>5、【责任】本人独立完成此项目前端体系从0到1的完整构建，包括UI设计、技术架构搭建、前后端数据对接、核心业务开发、用户体验优化、全流程测试及产品迭代升级等工作。`
		  }, {
		    tip: '作品演示',
		    video: `./static/video3.mp4`
		  }],
		  // 政务叫号
		  [{
		    tip: '项目名称',
		    detail: '镇赉县/通榆县政务叫号系统（多端：微信小程序、自助机桌面应用、B端管理系统、安卓屏App、评价器App、手持端）',
		    bold: true
		  }, {
		    tip: '开发时间',
		    detail: '2024.04 - 2024.09'
		  }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【作品地址】微信小程序搜索“镇赉县政务办事预约”，其他端均在线下或在内部系统中，无法查看。
		  				<br/>2、【项目概况】基于WebSocket实时通信技术，构建多终端协同系统，实现政务机构线上预约与线下叫号全流程管理。
						<br/>用户通过小程序预约线下取号，数据实时同步至政务大厅大屏和叫号终端；系统智能分配队列，支持过号重排场景，并通过语音/屏幕双重提示，提升办理效率。
						<br/>
						<br/>3、【主要功能】
						<br/>（1）小程序端：主要提供预约、查看预约记录、咨询电话查询、查看业务详情和申报材料，预约办理等功能；
						<br/>（2）自助机端：配置业务、读取身份证、现场取号、打印小票；
						<br/>（3）安卓屏APP端：大屏幕放在大厅中心，实时展示当前所有业务正在办理和待办理的号数；小屏幕在每个业务窗口上方，显示工作人员信息、业务信息、当前办理状态、正在办理的号数等；
						<br/>（4）评价器APP端：配置业务、根据实时收到的消息显示不同状态的页面：已登录、未登录、通知叫号（正在办理、服务评价、重新叫号）等。
						<br/>
				<br/>4、【技术栈】electron、element-ui、uniapp、uview等。
		  		<br/>5、【责任】本人负责除B端管理系统、手持设备外的各端UI设计、前端开发、产品迭代等工作。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000镇赉叫号.jpg`,
		  		`0000镇赉叫号2.jpg`,
		  	]
		  }],
		  // 医院支付宝
		  [{
		    tip: '项目名称',
		    detail: '吉林市各医院挂缴查小程序（微信、支付宝小程序）',
		    bold: true
		  }, {
		    tip: '开发时间',
		    detail: '2021.02 - 2021.04'
		  }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【作品地址】支付宝或微信搜索"吉林市人民医院"、支付宝搜索"北华大学附属医院互联网平台"、"吉林市中心医院互联网平台"，进入小程序可查看线上作品。
		  							<br/>2、【项目概况】与各医院的HIS系统对接，实现挂号、门诊缴费、报告查询功能的小程序，为患者增加就诊方式。
		  							<br/>3、【主要功能】患者添加或选择就诊卡、人脸识别、生成就诊卡、挂号、退号、门诊缴费、报告查询、住院缴费、AI问诊、微信或支付宝支付、支付宝埋点云监控等。
		  							<br/>4、【技术栈】uniapp、uview、支付宝云监控等。
		  							<br/>5、【责任】本人独立完成此项目前端体系从0到1的完整构建，包括UI设计、技术架构搭建、前后端数据对接、核心业务开发、用户体验优化、及产品迭代升级。
		  			`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000挂缴查.jpg`,
		  		`0000挂缴查2.jpg`,
		  	]
		  }],
		  // 智慧食堂
		  [{
		    tip: '项目名称',
		    detail: '人民医院智慧食堂（微信小程序、B端管理系统、桌面实时打印小票应用）',
		    bold: true
		  }, {
		    tip: '开发时间',
		    detail: '2025.05 - 2025.06'
		  }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【项目介绍】医院食堂通过患者在小程序上的点餐情况提前进行备餐，并根据次日的预约点餐情况提前管理库存、准备配菜，并提供配送；在B端管理系统上传菜品、监控配送；在桌面应用查看当日订单、预约订单的数量和详情，连接热敏打印机、贴票打印机两种打印机进行小票打印（当前实时打印、预约订单打印、小票预览、补打小票）。
		  		<br/>2、【技术栈】electron、element-ui、uniapp、uview等。
		  		<br/>3、【责任】本人负责小程序端无设计稿页面美化、分模块前端开发；桌面应用端无设计稿页面美化、整体前端业务处理等工作。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000智慧食堂打印程序.jpg`,
		  	]
		  }],
		  // 智慧招生
		  [{
		    tip: '项目名称',
		    detail: 'AI问答智慧招生（微信小程序）',
		    bold: true
		  }, {
		    tip: '开发时间',
		    detail: '2025.04 - 2025.05'
		  }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【作品地址】微信小程序搜索“吉林经济贸易学校智慧招生”。
				<br/>2、【项目介绍】协助经贸学校的招生老师进行招生工作，主推AI智能问答功能（对接后端调试训练的coze工作流），次要功能为：介绍学校的各种招生计划、收费标准、专业、学校概况，以及根据专业能力测试推荐相关专业等。
		  		<br/>3、【技术栈】uniapp、uview、coze等。
		  		<br/>4、【责任】本人负责小程序端无设计稿页面美化、分模块前端开发等工作。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000智慧校园.jpg`,
		  		`0000智慧校园2.jpg`,
		  	]
		  }],
		  // 对账系统
		  [{
		    tip: '项目名称',
		    detail: '人民医院窗口支付对账系统（B端管理系统）',
		    bold: true
		  }, 
		  // {
		  //   tip: '开发时间',
		  //   detail: '时隔太久记不清'
		  // }, 
		  {
		    tip: '负责标签',
		    detail: 'FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【项目介绍】对人民医院的门诊、食堂、档案室、停车场等部门账目进行管理（查询、退款、汇总等），解决医院频繁的错账找平需求。角色分为管理员、收款员、财务。
				<br/>2、【主要功能】主要有角色管理、门店管理、修改密码、订单汇总、订单查找/退款等功能
		  		<br/>2、【技术栈】vue.js、element-ui等。
		  		<br/>3、【责任】本人负责整体的前端开发、产品迭代等工作。`
		  }],
		  // 志愿者
		  [{
		    tip: '项目名称',
		    detail: '志愿者平台（微信小程序）',
		    bold: true
		  }, {
		    tip: '开发时间',
		    detail: '2023.02 - 2023.04'
		  }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
		    tip: '项目描述',
		    detail: `<br/>1、【项目介绍】协助市志愿者协会开展志愿活动，让志愿者实现线上报名。
		  		<br/>2、【主要功能】
				<br/>（1）功能：注册、登录验证、实名认证、发放志愿者证书、扫码签到、个人信息管理、活动管理、组织机构管理、人员管理、人员审核、机构审核。
				<br/>（2）无组织、未入驻组织的用户根据角色选择（组织管理员、志愿者）进行申请创建组织、或加入组织。
				<br/>（3）志愿者登录后可看到活动大厅按钮，从活动列表进入活动详情，可在此进行报名、查看活动信息、查看举办活动的组织信息。
				<br/>（4）组织管理员、超级管理员登录后可进行各种审核和管理的相关工作。
				<br/>（5）实名认证处显示：审核状态、制卡状态、重新提交按钮。
				<br/>（6）“志愿者/管理员”根据扫描“活动码/人员码”进行“签到/查看人员信息”的操作。
				<br/>3、【技术栈】uniapp、uview等。
		  		<br/>4、【责任】本人负责UI设计、分模块前端开发、产品迭代等工作。`
		  }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000志愿者.jpg`,
		  		`0000志愿者2.jpg`,
		  	]
		  }],
		  // 北华医院排班系统
          [{
            tip: '项目名称',
            detail: '北华大学附属医院医生排班系统（B端管理系统）',
            bold: true
          }, 
		  // {
    //         tip: '开发时间',
    //         detail: '时隔太久记不清'
    //       }, 
		  {
		    tip: '负责标签',
		    detail: 'FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【项目介绍】给医生排班，以便患者在小程序进行挂号操作。
                <br/>2、【主要功能】科室管理、医生管理、专家号管理、排班管理、普通号排班等功能。
          		<br/>3、【技术栈】uniapp、element-ui等。
          		<br/>4、【责任】本人负责前端开发、产品迭代等工作。`
          }],
		  // 源咖离线
          [{
            tip: '项目名称',
            detail: '源咖小说离线神器（桌面应用）',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2022.02 - 2022.02'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【项目概况】获取离线小说资源。
							<br/>2、【主要功能】纯前端实现解析小说目录、解析小说正文，选中某些章节区间、生成txt、修改历史记录、上传txt文件去除每章前后重复多余广告文字等功能。
							<br/>3、【技术栈】electron、vue、element-ui
							<br/>4、【责任】本人全权负责设计原型、产品LOGO、UI设计、前端整体架构搭建、前端开发、优化用户体验、测试、产品迭代等工作。`
          }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0001源咖离线神器.jpg`,
		  	]
		  }, {
            tip: '作品演示',
            video: `./static/video1.mp4`
          }],
		  // 陪护证
          [{
            tip: '项目名称',
            detail: '吉林市人民医院电子治疗单（微信小程序）',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2021.08 - 2021.08'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【作品地址】该项目已合并至人民医院挂缴查微信小程序中，微信搜索"吉林市人民医院"，点击"电子治疗单"可查看。
              <br/>2、【项目概况】供医生给需要多次来院治疗的患者进行线上发证，线上管理功能。
							<br/>3、【主要功能】
							<br/>（1）医生端：扫描患者健康卡/治疗单二维码，① 给未创建的患者选择治疗项目，创建治疗单；②给已创建的患者进行作废、治疗、查看操作记录汇总（已发单、已治疗、已作废）、查看三个类型的所有操作记录详情等操作。
							<br/>（2）患者端：根据状态查询治疗单、未被创建过的患者出示健康卡二维码，已有治疗单患者出示治疗单二维码。
							<br/>4、【技术栈】uniapp、uview等。
							<br/>5、【责任】本人负责无设计稿页面美化、前端开发等工作。`
          }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`031治疗单-医生.jpg`,
		  		`031治疗单-患者.jpg`,
		  	]
		  }],
		  // 江城易检
          [{
            tip: '项目名称',
            detail: '基层疫情上报管理平台/又名“江城易检”（微信小程序）',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2020.12 - 2021.01'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【作品地址】该项目已下线，暂不可查看。
							<br/>2、【项目概况】疫情期间，供吉林市所有农村卫生室、诊所等小型医疗机构上报就诊患者个人信息、健康信息、旅居史等信息，方便吉林市卫健委统一管理追源。
							<br/>3、【主要功能】居民健康卡注册、管理员登录、医生手动或扫码上报看病人员信息、本机构管理医生、卫健委统计报表等功能。
							<br/>4、【技术栈】uniapp、uview、微信电子健康卡等。
							<br/>5、【责任】本人负责UI设计（无设计稿情况下直接创建空白vue页面，边改代码边设计）、前端开发、产品迭代等工作。 `
          }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`050江城易检.png`,
		  	]
		  }],
		  // 趣拍拍
          [{
            tip: '项目名称',
            detail: '趣拍拍商城（微信公众号）',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2020.10 - 2020.12'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【作品地址】该项目已下线，暂不可查看。
							<br/>2、【项目概况】一个购买商品可返佣的商城公众号。
							<br/>3、【主要功能】登录注册、购买商品、分享或购买商品返佣、统计佣金、商家查看会员等。
							<br/>4、【技术栈】uniapp、uview等。
							<br/>5、【责任】本人负责整体UI设计、前端开发等工作。`
          }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000趣拍拍.jpg`,
		  		`0000趣拍拍2.jpg`,
		  	]
		  }],
		  // 吉林市人民政府
          [{
            tip: '项目名称',
            detail: '吉林市政府网站集约化（web网站）',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2017.03 - 2020.09'
          }, {
		    tip: '负责标签',
		    detail: 'WD'
		  },{
            tip: '项目描述',
            detail: `<br/>【作品地址】部分网站已下线，可回到上一页，进入“网页”页面查看网站。
              <br/>【项目概况】本人负责：
							<br/>2018年上线的老版吉林市人民政府、
							<br/>2020年上线的新版吉林市人民政府、
              <br/>2017-2020间吉林市人民政府所有专题网页、
              <br/>吉林市政数局、
							<br/>吉林市政府诉求平台、
							<br/>吉林市执法局、
							<br/>吉林市松花湖管委会、
							<br/>永吉北大壶管委会、
							<br/>吉林市国资委、
							<br/>吉林市机关事务管理局、
							<br/>吉林市地震局等各网站。
							<br/>配合北京拓尔思公司的后台管理系统，实现吉林市政府下辖所有单位网站的数据整合，达到政府网站的统一管理与上线。
              <br/>【技术栈】Jquery
              <br/>【责任】网页设计 + 网页制作`
          }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0001吉林市人民政府.jpg`,
		  	]
		  }],
		  // 个人网站
          [{
            tip: '项目名称',
            detail: '个人网站（web网站兼容手机端；2017版、2022版）',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2017.10（2017版） / 2022.06（2022版UI设计） / 2025.07（2022版前端）'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【作品地址】本站为此项目2022年版本，2017年版本可回到第一页选择“2017版”查看。
              <br/>2、【项目概况】个人作品集、设计能力、开发能力展示（国外托管所以加载速度过慢）。
              <br/>3、【主要功能】将记录个人信息的json格式数据显示到页面上，最后通过webpack打包，并布置到github仓库中，使用github博客模式生成个人网站。
              <br/>最佳适配为PC端1920分辨率的屏幕，此分辨率观看效果最佳。
              <br/>4、【技术栈】vue.js、github。
              <br/>5、【责任】此项目本人全权负责。`
          }, {
		    tip: '作品展示',
		  	detail: '',
		    img: [
		  		`0000个人网站.jpg`,
		  		`0000个人网站2.jpg`,
		  		`0002个人简历网站.jpg`,
		  	]
		  }],
          // [{
          //   tip: '项目名称',
          //   detail: '天气预报(webApp)',
          //   bold: true
          // }, {
          //   tip: '开发时间',
          //   detail: '2019.07 - 2019.07'
          // }, {
          //   tip: '项目描述',
          //   detail: `<br/>1、【作品地址】该项目已下线，暂不可查看。
          //             <br/>2、【项目概况】天气预报webApp。
          //             <br/>3、【主要功能】获取在线天气数据，并根据用户选择的城市展示相关城市最近五天的天气预报，利用localStorage，增删城市列表。
          //             <br/>4、【技术栈】vue.js。
          //             <br/>5、【责任】本人负责UI设计、前端开发。`
          // }],
		  // 企业协作平台
          [{
            tip: '项目名称',
            detail: '企业协作平台(B端管理系统)',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2018.06 - 2018.07'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【作品地址】该项目已下线，可回到上一页，进入“网页”页面查看“mock数据版”。
                <br/>2、【项目概况】企业内多团队多人协作、任务分发的B端系统。
                <br/>3、【主要功能】<br/>用户添加项目，并邀请相关人员参与项目，更改项目封面，删除项目；
               <br/>进入项目可以增加任务，规定任务时间、参与人员，规定任务内容，选择任务的紧急程度，也可以修改任务状态及其他任务相关信息，删除任务，鼠标拖动修改任务列表顺序；
							<br/>用户注册时，填好用户名、密码信息、选好头像后，可以只输入身份证号，系统会自动根据身份证号输入出生日期、年龄、及所在省市县。
                <br/>4、【技术栈】vue.js、ui库muse ui、模拟数据插件mock.js。
                <br/>5、【责任】本人负责整体UI设计、前端架构搭建、mock数据等工作。`
          }],
		  // 树洞日记
          [{
            tip: '项目名称',
            detail: '树洞日记(微信小程序)',
            bold: true
          }, {
            tip: '开发时间',
            detail: '2018.12 - 2019.01'
          }, {
		    tip: '负责标签',
		    detail: 'UI|FE'
		  },{
            tip: '项目描述',
            detail: `<br/>1、【作品地址】该项目已下线，可在右侧视频中查看。
              	<br/>2、【项目概况】记录日记、边听音乐边查看匿名日记舒缓心情的小程序，该小程序可做日记本也可做吐槽树洞，日记与吐槽的树洞可相互转化，同时也可查看其他用户的匿名吐槽树洞。
              	<br/>3、【主要功能】实现授权登录、默认注册用户、私密日记和公开匿名日记的增删改及相互切换、日记加密、私密日记输入密码查看、推送/刷新随机10篇匿名日记、音乐的播放及切换等功能。
                <br/>4、【技术栈】mpvue、小程序云开发。
              	<br/>5、【责任】此项目本人全权负责。`
          }, {
            tip: '作品演示',
            video: `./static/video2.mp4`
          }]
        ]
      }
    ],
    pics: [],
    webs: [ 
      {
        src: './static/items/work/work.html',
        srcCut: 'work',
        name: '企业协作平台',
        startTime: '2020.09',
        // endTime: '至今'
      },
	  {
        src: './static/items/szf/index.html',
        srcCut: 'szf',
        name: '吉林市人民政府',
        startTime: '2017.05',
        isOnline: false
      }, 
	  {
        src: './static/items/csm/topic_card.html',
        srcCut: 'csm',
        name: '吉林市城市名片',
        startTime: '2017.05',
        isOnline: false
      },
      {
        src: './static/items/yzh/yzh.html',
        srcCut: 'yzh',
        name: '云之红官网',
        startTime: '2019.04',
      },
	  {
        src: 'http://www.jlcity.gov.cn/zt/zwzt/lhzt/',
        srcCut: 'lhz',
        name: '两会专题',
        startTime: '2018.01',
        isOnline: true
      },
      {
        src: './static/items/kjy/topic_fish_index.html',
        srcCut: 'kjy',
        name: '吉林市开江鱼美食节',
        startTime: '2018.04',
        isOnline: false
      },
      {
        src: './static/items/ccs/twelve_index.html',
        srcCut: 'ccs',
        name: '创城十二时辰',
        startTime: '2019.11',
        isOnline: false
      },
      {
        srcCut: 'gbz',
        name: '干部作风大整顿',
        startTime: '2018.09',
        isOnlyPic: true
      },
      {
        src: 'http://www.jlcity.gov.cn/sqpt/',
        srcCut: 'zfs',
        name: '吉林市政府诉求平台',
        startTime: '2017.12',
        isOnline: true
      },
      {
        src: 'http://www.jlcity.gov.cn/zt/zwzt/zfjs/',
        srcCut: 'zfjs',
        name: '吉林市政府建设专栏',
        startTime: '2017.10',
        isOnline: true
      },
      {
        src: './static/items/hdb/topic_white_index.html',
        srcCut: 'hdb',
        name: '桦甸白桦节',
        startTime: '2017.04',
        isOnline: false
      },
      {
        srcCut: '24x',
        name: '吉林24小时',
        startTime: '2019.09',
        isOnlyPic: true
      },
      {
        src: './static/items/wla/wla.html',
        srcCut: 'wla',
        name: '网络安全法',
        startTime: '2018.05'
      },
      {
        src: './static/items/zwf/num_index.html',
        srcCut: 'zwf',
        name: '数字化管理局',
        startTime: '2020.08',
        isOnline: false
      },
      {
        src: './static/items/bdh/bdh.html',
        srcCut: 'bdh',
        startTime: '2017.06',
        name: '北大壶管委会'
      },
      {
        src: 'http://www.jlcity.gov.cn/bmwz/zfj/',
        srcCut: 'zfj',
        name: '吉林市执法局',
        startTime: '2017.03',
        isOnline: true
      },
      {
        src: 'http://www.jlcity.gov.cn/zt/sjjq/gkkjl/',
        srcCut: 'c60',
        name: '从60万米高空看吉林',
        startTime: '2019.09',
        isOnline: true
      },
      {
        src: './static/items/zjs/topic_thisIsJilin_index.html',
        srcCut: 'zjs',
        name: '这就是吉林市',
        startTime: '2020.04',
        isOnline: false
      },
      {
        src: './static/items/jcg/topic_mechanic_index.html',
        srcCut: 'jcg',
        name: '江城工匠',
        startTime: '2018.05',
        isOnline: false
      },
      {
        src: './static/items/shc/topic_govbuild_index.html',
        srcCut: 'shc',
        name: '扫黑除恶',
        startTime: '2019.04',
        isOnline: false
      },
      {
        src: './static/items/jlt/html/login.html',
        srcCut: 'jlt',
        name: '吉路通公路管理系统',
        startTime: '2019.04',
        isApp: true
      },
      {
        src: './static/items/wxy/html/register.html',
        srcCut: 'wxy',
        name: '微心愿',
        startTime: '2019.03',
        isApp: true
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/common/js/db.js